import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    padding: '1px',
    backgroundColor: '#fc9',
    pointerEvents: 'none',
    minWidth: 44,
    height: 18,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '12px',
    borderRadius: 2
  }
};

const enhance = compose();

const button = enhance(({ classes }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      className={classes.button}
      tabIndex="-1"
    >
      任意
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
